<template>
  <v-list-item-action>
    <v-menu
      v-model="menu"
      offset-y
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-show="user"
          icon
          small
          v-on="on"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
  
      <v-list>
        <v-list-item
          @click="$refs.updatePassword.toggleDialog()"
        >
          <v-list-item-title>                             
            Change Password
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          :disabled="currentPersonUid === (user || {}).person_uid"
          @click="$refs.updateUsername.toggleDialog()"
        >
          <v-list-item-title>                             
            Change Username
          </v-list-item-title>
        </v-list-item>
      </v-list>
      
      <user-password-dialog-edit
        ref="updatePassword"
        :old-password-required="false"
        :user="user"
        :system-setting-value="systemSettingValue"
      />
      
      <user-username-dialog-edit
        ref="updateUsername"
        :user="user"
        :system-setting-value="systemSettingValue"
        @updated="$emit('updated')"
      />
    </v-menu>
  </v-list-item-action>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      UserPasswordDialogEdit: () => import('@/components/hris/user/password/DialogEdit'),
      UserUsernameDialogEdit: () => import('@/components/hris/user/username/DialogEdit'),
    },
    props: {
      user: {
        type: Object,
        default: null,
      },
      systemSettingValue: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        menu: false,
        currentPersonUid: '',
      }
    },
    computed: {
      ...mapState(['currentEmployee']),
    },
    created () {
      this.loadCurrentPerson()
    },
    methods: {
      loadCurrentPerson () {
        const person = (JSON.parse(localStorage.getItem('user')) || {}).person || {}
        this.currentPersonUid = person.person_uid
      },
    },
  }
</script>
